import { render, staticRenderFns } from "./ImageUi.vue?vue&type=template&id=08024173&scoped=true"
import script from "./ImageUi.ts?vue&type=script&lang=ts&external"
export * from "./ImageUi.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageUi.scss?vue&type=style&index=0&id=08024173&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08024173",
  null
  
)

export default component.exports